module.exports = __webpack_public_path__ + "static/media/custom-modal.e9920b94.svg";